export const cancelledredlabel = <span style={{ color: 'red' }}>Cancelled</span>
export const completedgreenlabel = <span style={{ color: 'green' }}>Completed</span>
export const styleforsmallstsar = { fontSize: 12 };